export const STATUS = {
  INFO: 0,
  SUCCESS: 1,
  WARNING: 2,
  ERROR: 3
};

export default STATUS;
